import React from "react";
import "./otherProduct.scss";
import {Title} from "../../elements/Title/title";
import { Link } from "gatsby";
import classNames from "classnames";
import Image from "../Image/image.js";


export const OtherProduct = props => {
    const type_card = "card";
    const type_account = "account";
    const title = props.title;
    const products = props.products;
    const type = props.type;


    const classnames = classNames(`m-related`, {

    });

    return (
        <div className={props.className ? props.className + ` ` + classnames : classnames}>
            {title && (
                <Title className={`marg-b16`} id={props.id} tag={`h2`} size16 content={title} />
            )}

            {type === type_card && (

                <ul>
                    {products.map((value, index) => (
                        <li  key={index}>
                            <Link to={`/${value.slug}/`}>{value.name}</Link>
                            <Image filename={value.image_logo}/>
                            <p>{value.bank_name}</p>
                            <p>{value.short_name}</p>
                            {
                                Object.keys(value.transmitter).map(function(d){

                                    return <p>{value.transmitter[d]["name"]}</p>
                                })
                            }
                            <p>{value.cost_rate}</p>
                            <p>{value.cost_admin}</p>
                        </li>
                    ))}
                </ul>
            )}

            {type === type_account && (

                <ul>
                    {products.map((value, index) => (
                        <li  key={index}>
                            <Link to={`/${value.slug}/`}>{value.name}</Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default OtherProduct;